import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledRefreshIcon = styled.svg<IconProps>`
  .cls-1 {
    fill: none;
  }

  .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.hover:hover,
  &.active {
    .cls-2 {
      fill: var(--du-color-primary, #128370);
    }
  }
`;

const RefreshIcon: React.FC<IconProps> = props => {
  let activeClass = props.active ? 'active' : '';
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledRefreshIcon
      id='Refersh-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='-220 -220 1000 1000'
      className={activeClass}
    >
      <g id='Privacy' transform='translate(6.5 0.5)'>
        <rect id='Margin_Rectangle' data-name='Margin Rectangle' className='cls-1' width='32' height='32' />
        <path
          id='gap'
          className='cls-2'
          rx='1'
          transform='translate(8 8)'
          d='M449.9 39.96l-48.5 48.53C362.5 53.19 311.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.97 5.5 34.86-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c37.96 0 73 14.18 100.2 37.8L311.1 178C295.1 194.8 306.8 223.4 330.4 224h146.9C487.7 223.7 496 215.3 496 204.9V59.04C496 34.99 466.9 22.95 449.9 39.96zM441.8 289.6c-16.94-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-37.96 0-73-14.18-100.2-37.8L200 334C216.9 317.2 205.2 288.6 181.6 288H34.66C24.32 288.3 16 296.7 16 307.1v145.9c0 24.04 29.07 36.08 46.07 19.07l48.5-48.53C149.5 458.8 200.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z'
        />
      </g>
    </StyledRefreshIcon>
  );
};

export default RefreshIcon;
